<template>
<div class="popup" v-cloak v-if="retryShow">
    <div class="content" id="retryFailed">
        <div class="title">
            {{$t('language.common.failedFiles')}}
            <div class="icon white-close dialog-close" @click="closePage()"></div>
        </div>
        <div class="retry-body">
            <div class="retry-buttons">
                <button class="retry-button" @click="retry()">
                    <div class="icon-util retry retry-button-position"></div>{{$t('language.common.retry')}}
                </button>
            </div>
            <div class="retry-contens">
                <table border="0" cellpadding="0" cellspacing="0" style="width:100%;">
                    <thead style="width:638Px;">
                        <tr class="retry-th">
                            <th width='21.5%' fixed="true">
                                <div style="float:left;top:10Px;" class="icon-util failed-retry-position" :class="selectedArr.length!=0&&(selectedArr.length == (unfinishData.length-retryedArr.length))?'check-small':'nocheck-small-blue'" @click="checkedAll()"></div>
                                <span v-if="!selectedArr.length" style="float:left;">{{$t('language.common.name')}}</span>
                                <span v-if="selectedArr.length" class="selected-style" :title="selectedArr.length+$t('language.common.itemsSelected')">{{selectedArr.length}} {{$t('language.common.itemsSelected')}}</span>
                            </th>
                            <th width='13%' fixed="true">{{$t('language.common.size')}}</th>
                            <th width='26.5%' fixed="true">{{$t('language.common.sourceDir')}}</th>
                            <th width='27%' fixed="true">{{$t('language.common.cause')}}</th>
                        </tr>
                    </thead>
                    <tr class="failed-retry-tr" v-for="(item, index) in unfinishData" :key="index">
                        <td width='156Px' style="float:left;">
                            <div v-if="!item.retryed" class="icon-util failed-retry-position" style="float:left;" :class="selectedArr.includes(item)?'check-small':'nocheck-small-blue'" @click="selectItem(item)"></div>
                            <div v-if="item.retryed" style="float:left;cursor:pointer;" class="icon-util eye view-logs-eye failed-retry-position" title="View" @click="viewBack(item)"></div>
                            <div class="failed-files-one" :title="item.filename">{{item.filename}}</div>
                        </td>
                        <td width='95Px'  style="float:left;">{{item.filesize|formatLogByte}}</td>
                        <td width='192Px' class="item-dire" @click="tofailedSourceCategroy(item)" v-show="item.cloudtype!=='Shares'" :title="item.sourceNode|getCatalog|getCatalogTitle">{{item.sourceNode|getCatalog}}</td>
                        <td width='192Px' class="item-dire" @click="tofailedShareCategroy(item)" v-show="item.cloudtype==='Shares'" :title="item.sourceNode|getCatalogShare|getCatalogTitle">{{item.sourceNode|getCatalogShare}}</td>
                        <td width='195Px' style="float:left;">
                            <div class="failed-files-two"  :title="item.cause|getCauseReason">{{item.cause|getCauseReason}}</div>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="retry-footer">
                <a href="https://www.multcloud.com/help/limitations.html" target="_blank" class="retry-limits">{{$t('language.popup.limits')}}</a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
import commonstate from '@/js/constant.js';
export default {
    data: function () {
        return {
            retryShow: false,
            retryPromptShow: false,
            selectedArr: [],
            unfinishData: [],
            transferType: '',
            flag: true,
            retryFrom: [],
            retryedArr: [],
            retryToArr: [],
            currentIndex: -1,
            retryAllData: []
        };
    },
    methods: {
        cleanList() {
            this.unfinishData = null;
        },
        selectItem(item) {
            this.retryPromptShow = false;
            if (this.selectedArr.includes(item)) {
                this.selectedArr = this.selectedArr.filter(function (ele) {
                    return ele != item;
                });
            } else {
                this.selectedArr.push(item);
                
            }
        },
        checkedAll() {//选中所有的数据
            if (this.selectedArr.length == (this.unfinishData.length - this.retryedArr.length)) {
                this.selectedArr = [];
            } else {
                this.selectedArr = [];
                for (let i = 0; i < this.unfinishData.length; i++) {
                    if (!this.unfinishData[i].retryed) {
                        this.selectedArr.push(this.unfinishData[i]);
                    }
                }
               
            }
        },
        retry() {//开始重试操作
            let options;
            let remove;
             this.$store.state.snapTaskShow = true;
            let user = JSON.parse(localStorage.getItem("user"));
            //流量不足弹窗提醒
             let usedTraffic = user.usedBytes;
            // if(user.vip&&user.payLevel>1){
            //     usedTraffic = user.payUsedTraffic;
            // }
            if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
                this.$parent.$refs.upgradeDialog.upgradeShow = true;
                this.$parent.$refs.upgradeDialog.reset();
                this.$parent.$refs.upgradeDialog.trafficShow = true;
                return false;
            }
            if (this.selectedArr.length) {
                let fromItemArr = [];
                let that = this;
                this.currentIndex = -1;
                let retryAllData = Object.assign([], this.selectedArr);
                this.retryAllData = retryAllData;
                this.selectedArr = [];
                let toItems = this.packageToItem(retryAllData[0]);
                for (let i = 0; i < retryAllData.length; i++) {
                    let fromItems = this.packageFromItem(retryAllData[i]);
                    retryAllData[i].retryed = true;
                    if (this.retryAllData[i].remove) {
                        options = {
                            isRemove: 1,
                            isChar: 1
                        }
                        remove=true;
                    } else {
                        options = {
                            isRemove: 0,
                            isChar: 1
                        }
                    }
                    fromItemArr.push(fromItems);
                }
                commonUtils.judgeNewDataFlag(that);
                commonUtils.packageDetailData(fromItemArr,toItems,remove);//把数据放在临时任务待执行弹窗
                let addData = new taskTransferUtils.addTaskData(user.id, 4, fromItemArr[0].filename, fromItemArr, toItems, options, null);
                that.Utils.doTasksRequest('add', addData).then(res => {//调用add接口
                    if (res.status == 200) {
                        commonUtils.letFlagTrue(that);
                        commonUtils.packageHaveDataDetail(res.tasks);//把返回的taskId给待处理任务
                    }else if(res.status == 400&&res.reason=='permissionFail'){
                        commonUtils.removeDataDetail(addData);
                        that.$toast({
                            text: that.$t('language.exception.notPermission'),
                            type: 'fail',
                            idValue: "rightBo",
                            duration:5000
                        });
                    }
                });
            } else {
                this.$toast({
                    text: this.$t('language.common.selectNull'),
                    type: 'fail',
                    idValue: "rightBo"
                });
            }
        },
        tofailedSourceCategroy(item) {//跳转到失败的源目录
            let direction = this.$parent;
            let that = this;
            commonUtils.toSourceCatalog(item, this, function (res) {
                if (res.status == 200) {
                    that.$nextTick(function () {
                        commonUtils.selectOption(item.sourceNode, direction);//选中最侧的云盘
                        let pathData = that.$store.state.pathJson[res.id + item.sourceToken];
                        const vm = window.vm.$children[0].$refs.routerView.$refs.routView;
                        commonUtils.encapsulationPath(item.sourceNode, pathData, vm);//封装路径
                        that.$store.state.catalogFileId = item.sourceNode[0].fileId;
                        commonUtils.ifHasDataSelect(vm);//看是否选中一个文件/文件夹
                    });
                }
            });
        },
        tofailedAimCategroy(item) {//跳转到失败的目标目录
            let direction = this.$parent;
            let that = this;
            commonUtils.toAimSourceCatalog(item, this, function (res) {
                if (res.status == 200) {
                    that.$nextTick(function () {
                        commonUtils.selectOption(item.desNode, direction);//选中最侧的云盘
                        let pathData = that.$store.state.pathJson[res.id + item.desToken];
                        const vm = window.vm.$children[0].$refs.routerView.$refs.routView;
                        commonUtils.encapsulationPath(item.desNode, pathData, vm);//封装路径
                    });
                }
            });
        },
        tofailedShareCategroy(item) {//跳转到失败的分享页目录
            let allNodes = item.sourceNode;
            let nodes = commonUtils.getSharePathForCryptId(item);
            if(nodes){
                this.$store.commit("setSharePath", nodes);
            }
            //分享路径是否指向子目录，是则获取分享文件fileId，否则获取任务文件id
            let link = commonstate.sharePageUrl + allNodes[allNodes.length-1].fileId;
            window.open(link);
        },
        packageFromItem(selectData) {//封装临时任务传输的源数据
            let fromItem = {};
            let nodes = selectData.sourceNode;
            fromItem.fileId = selectData.fileid;
            fromItem.filename = selectData.filename;
            if (selectData.filesize) {
                fromItem.filesize = selectData.filesize;
            }
            fromItem.driveId = selectData.sourceToken;
            fromItem.driveType = selectData.cloudtype;
            if(fromItem.driveType=='team'){
                fromItem.way="sub";
            }else if(fromItem.driveType=='Shares'){
                fromItem.way="share";
            }
            fromItem.isDir = selectData.isDir;
            if (selectData.sourceNode.length > 1) {
                fromItem.pid = selectData.sourceNode[selectData.sourceNode.length-1].fileId;
            } else {
                fromItem.pid = selectData.sourceNode[0].fileId;
            }
            fromItem.nodes = nodes;
            $.each(fromItem.nodes, function (i, item) {
                delete item.tokenId;
                delete item.cloudType;
                if (item.fileName) {
                    item.filename = item.fileName;
                }
                delete item.fileName;
            });
            if(selectData.webUrl) {
                fromItem.webUrl = selectData.webUrl;
            }
            return fromItem;
        },
        packageToItem(selectData) {//封装临时任务传输的目标目录数据
            let arr = [];
            let toItem = {};
            toItem.fileId = selectData.desid;
            toItem.filename = selectData.desname;
            toItem.driveId = selectData.desToken;
            toItem.driveType = selectData.desCloudType;
            toItem.isDir = true;
            if (selectData.desNode.length > 1) {
                toItem.pid = selectData.desNode[1].fileId;
            } else {
                toItem.pid = selectData.desNode[0].fileId;
            }
            if(toItem.driveType=='team'){
                toItem.way="sub";
            }else if(toItem.driveType=='Shares'){
                toItem.way="share";
            }
            let nodes = selectData.desNode;
            toItem.nodes = nodes;
            $.each(toItem.nodes, function (i, item) {
                delete item.tokenId;
                delete item.cloudType;
                if (item.fileName) {
                    item.filename = item.fileName;
                }
                delete item.fileName;
            });
            arr.push(toItem);
            return arr;
        },
        viewBack(item) {//关闭界面，跳转到失败目标目录
            this.closePage();
            this.tofailedAimCategroy(item);
        },
        closePage() {//关闭界面
            this.retryShow = false;
            this.$parent.$refs.detailedProgrss.detailedProgressShow = true;
            $.each(this.unfinishData, function (i, item) {
                item.retryed = false;
            })
        },
    },
};
</script>

<style>
.retry-td-three {
    width: 150px;
    /*no*/
}

.retry-td-one {
    width: 180px;
    /*no*/
}

.retry-td-two {
    width: 130px;
    /*no*/
}

#retryFailed {
    width: 680px;
    /*no*/
    height: 490px;
    /*no*/
}

.retry-body {
    width: 100%;
    height: 445px;
    /*no*/
    box-sizing: border-box;
    padding: 20px;
    /*no*/
}

.retry-buttons {
    width: 100%;
    height: 30px;
    /*no*/
}

.retry-button {
    height: 30px;
    /*no*/
    float: left;
}

.retry-broom-position {
    float: right;
    position: relative;
    top: 2px;
    /*no*/
}

.retry-broom-position:hover:after {
    content: attr(data-title);
    position: absolute;
    border: #8a96e3 solid 1px;
    /*no*/
    background: #fff;
    font-size: 13px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    padding: 2px;
    /*no*/
    border-radius: 2px;
    /*no*/
    z-index: 200;
    top: 20px;
    /*no*/
    left: 15px;
    /*no*/
    width: 60px;
    /*no*/
    height: 20px;
    /*no*/
    line-height: 20px;
    /*no*/
    white-space: nowrap;
}

.retry-contens {
    width: 100%;
    height: 330px;
    /*no*/
    box-sizing: border-box;
    margin-top: 10px;
    border: 1px solid #F0F0FB;
    /*no*/
    overflow: auto;
}

.retry-contens::-webkit-scrollbar {
    width: 8px;
    /*no*/
    height: 0px;
    /*no*/
    background-color: #fff;
}

.retry-contens::-webkit-scrollbar-thumb {
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}

.retry-position {
    position: relative;
    top: 3px;
    /*no*/
    margin-right: 13px;
    /*no*/
    left: 10px;
}

.retry-th {
    width: 100%;
    height: 35px;
    /*no*/
    line-height: 35px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: #a3adbd;
    margin: 0;
    background: #f2f7fe;
}

.retry-tr {
    width: 100%;
    height: 30px;
    /*no*/
    line-height: 30px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: #6f7886;
}

.retry-contens table tr th {
    font-weight: 300;
    text-align: left;
    table-layout: fixed;
}

.retry-contens table td {
    text-align: left;
    table-layout: fixed;
}

.retry-limits {
    font-size: 14px;
    /*no*/
    color: #2e79f6;
    float: left;
    text-decoration: none;
    line-height: 50px;
    /*no*/
}

.retry-button-position {
    float: left;
}

.retry-footer {
    position: absolute;
    bottom: 0;
}

.retry-prompt {
    font-size: 14px;
    /*no*/
    color: #FF1B46;
    position: relative;
    top: 30px;
    /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_exploer_popups/retry_detailProgress_failed_popup.vue